import type { GridSettings } from "@smartsuite/grid/lib/Grid.types";
import type { GridHeaderComponent } from "@smartsuite/grid/lib/components/GridHead/GridHead";
import { GridHead } from "@smartsuite/grid/lib/components/GridHead/GridHead";
import { GridHeadCellList } from "@smartsuite/grid/lib/components/GridHeadCellList/GridRowColumnsList";
import type { AppField } from "@smartsuite/smartsuite-client";

export const activityGridHeader: GridHeaderComponent<
  AppField,
  GridSettings
> = ({ side, left, ...props }) => {
  return (
    <GridHead
      className="activity-grid-header"
      {...props}
      side={side}
      left={left}
    >
      {/* @ts-expect-error */}
      <GridHeadCellList {...props} side={side} />
    </GridHead>
  );
};
